import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '../../../../../../components/mui/Core/index'
import Constants from '../../../../../../constants/en.json'
import {
  resetClientWarehouseCode,
  resetIsInviteConfirmed,
  resetSelectedOrganization,
  setEmail,
  setSelectedRole,
} from '../../invite-user-modal-slice'
import { useTheme } from '../../../../../../components/mui/Styles/index'

function SelectRole() {
  const theme = useTheme()
  const dispatch = useDispatch()
  const email = useSelector((state) => state.inviteUser.email)
  const [emailAddress, setEmailAddress] = useState(email)
  const selectedRole = useSelector((state) => state.inviteUser.selectedRole)
  const roles = useSelector((state) => state.userManagement.roles)
  const publicRoles = roles?.filter((role) => role?.publicRole)

  const handleOnChangeEmail = (event) => {
    setEmailAddress(event.target.value)
  }

  const handleOnBlurEmail = () => {
    dispatch(setEmail(emailAddress))
  }

  const handleSelectRole = (event) => {
    dispatch(setSelectedRole(event.target.value))
    dispatch(resetSelectedOrganization())
    dispatch(resetClientWarehouseCode())
    dispatch(resetIsInviteConfirmed())
  }

  const rootStyle = { minHeight: '257px' }
  const emailSectionStyle = { marginTop: '20px' }
  const emailFieldContainerStyle = { marginTop: '8px' }
  const emailFieldStyle = {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.secondary.main,
      },
    },
    margin: 0,
  }
  const roleSectionStyle = { marginTop: '20px' }
  const roleInputLabelStyle = {
    marginTop: '8px',
    '&.MuiInputLabel-root.Mui-focused': {
      color: theme.palette.secondary.main,
    },
  }
  const selectRoleContainerStyle = { marginTop: '8px' }
  const roleSelectStyle = {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.secondary.main,
    },
  }
  const selectRoleMenuProps = {
    PaperProps: {
      sx: {
        maxHeight: 250,
        overflowY: 'auto',
      },
    },
  }

  return (
    <Box sx={rootStyle}>
      <Box>
        <Typography variant='cardHeader'>
          {Constants.userManagement.inviteUser.INVITE_USER}
        </Typography>
      </Box>
      <Box sx={emailSectionStyle}>
        <Box>
          <Typography variant='cardMessage'>
            {`${Constants.userManagement.inviteUser.SEND_INVITE_TO}:`}
          </Typography>
        </Box>
        <Box sx={emailFieldContainerStyle}>
          <TextField
            id='invite-user-email-field'
            sx={emailFieldStyle}
            value={emailAddress}
            onChange={handleOnChangeEmail}
            onBlur={handleOnBlurEmail}
            label='Email'
            type='email'
            placeholder='Email'
            fullWidth
          />
        </Box>
      </Box>
      <Box sx={roleSectionStyle}>
        <Box>
          <Typography variant='cardMessage'>
            {`${Constants.userManagement.inviteUser.USER_ROLE}`}
          </Typography>
        </Box>
        <Box>
          <FormControl fullWidth>
            <InputLabel sx={roleInputLabelStyle}>
              {Constants.userManagement.inviteUser.ROLE}
            </InputLabel>
            <Box sx={selectRoleContainerStyle}>
              <Select
                sx={roleSelectStyle}
                fullWidth
                value={selectedRole || ''}
                onChange={handleSelectRole}
                MenuProps={selectRoleMenuProps}
              >
                {publicRoles?.map((item) => {
                  return (
                    <MenuItem key={item.roleName} value={item}>
                      {item.roleDescription}
                    </MenuItem>
                  )
                })}
              </Select>
            </Box>
          </FormControl>
        </Box>
      </Box>
    </Box>
  )
}

export default SelectRole
